import React = require("react");
import {connect} from 'react-redux';
import {iState} from "./store";
import {RadioConnected} from 'webmapsjs/dist/reactComponents/Radio'
import * as cnst from './constants';
import * as actions from './actions';
import {Slider} from 'webmapsjs/dist/reactComponents/Slider';


    //
    //         title: "Title",
    // items: ['one', 'two'],
    // callback: (val: string) => {},
    // selectedIndex: 0

export const Metric = connect(
    (s: iState) => {
        return {
            title: 'Metric',
            items: cnst.metrics,
            selectedIndex: cnst.metrics.indexOf(s.metric),
            inline: false,
            classes: ['metric-control']
        }
    },
    (dispatch) => {
        return {
            callback: (v) => {
                dispatch({type: actions.ACTION_CHANGE_METRIC, metric: cnst.metrics[v]} as actions.iChangeMetric);
            },
        }
    }
)(RadioConnected);

export const TimePeriod = connect(
    (s: iState) => {
        return {
            title: 'Time Period',
            items: cnst.times,
            selectedIndex: cnst.times.indexOf(s.the_time),
            inline: false,
            classes: ['times-control']
        }
    },
    (dispatch) => {
        return {
            callback: (v) => {
                dispatch({type: actions.ACTION_CHANGE_TIME, time: cnst.times[v]} as actions.iChangeTime);
            }
        }
    }
)(RadioConnected);


export const WeekSlider = connect(
    (s: iState) => {
        return {
            steps: cnst.numWeeks - 1,
            animate: true,
            defaultAnimationInterval: 700,
            value: s.week,

        }
    },
    (dispatch) => {
        return {
            change: (d: number) => {
                dispatch({type: actions.ACTION_CHANGE_WEEK, week: d} as actions.iChangeWeek);
            }
        }
    }
)(Slider);

class _WeekLabel extends React.Component<{the_time: string, week: number}, {}>{
    static startWkday = new Date('02/06/2020');
    static startSat = new Date('02/08/2020');

    render(){
        let refDate = new Date(_WeekLabel.startWkday);

        if (this.props.the_time === cnst.times[3]){
            refDate = new Date(_WeekLabel.startSat);
        }
        refDate.setDate(refDate.getDate() + 7 * this.props.week);

        return <p>
            {refDate.toDateString()}
        </p>
    }
}


export const WeekLabel = connect(
    (s: iState) => {
        return {
            the_time: s.the_time,
            week: s.week,
        }
    }
)(_WeekLabel);




//
// export interface iSliderOpt {
//     steps: number;
//     animate: boolean;
//     defaultAnimationInterval: number;
//     value: number;
// }
// export interface iSlider extends iSliderOpt {
//     change: (d: number) => any;
// }
// export declare class Slider extends React.Component<iSlider, {}> {
//     static defaultProps: {
//         steps: any;
//         animate: boolean;
//         defaultAnimationInterval: any;
//         value: any;







